import { render, staticRenderFns } from "./contentTitle.vue?vue&type=template&id=fc4aa0d0&scoped=true&"
import script from "./contentTitle.vue?vue&type=script&lang=js&"
export * from "./contentTitle.vue?vue&type=script&lang=js&"
import style0 from "./contentTitle.vue?vue&type=style&index=0&id=fc4aa0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4aa0d0",
  null
  
)

export default component.exports